import { breakpoints } from './breakpoints';

export const theme = {
  white: '#FFFFFF',
  lighterGray: '#E8EAEE',
  disabledGray: '#A09EA3',
  medGray: '#706F73',
  bbBlack: '#161819',
  primaryBlue: '#2490FF',
  primaryGreen: '#1BCD7B',
  mobileMediaQuery: `(max-width: ${breakpoints.large}px), (orientation: landscape) and (hover: none) and (pointer: coarse) and (max-height: ${breakpoints.large}px)`,
};

export default theme;
